// Core
import { IonicStorageModule } from "@ionic/storage";
import { NgModule, ErrorHandler } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { IonicApp, IonicModule, IonicErrorHandler } from "ionic-angular";
import { AngularFireModule, AuthMethods, AuthProviders } from "angularfire2";
import { MyApp } from "./app.component";

// Native plugins
import { Keyboard } from "@ionic-native/keyboard";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";

// Services
import { AssetService } from "../providers/asset";
import { FileService } from "../providers/file";
import { PostService } from "../providers/post";
import { SettingsService } from "../providers/settings";
import { StatsService } from "../providers/stats";
import { UiService } from "../providers/ui";
import { UserService } from "../providers/user";

// Pipes
import {
  HumanizeDate,
  PickTime,
  PickDate,
  FormatTime, ArticleDate,
} from "../pipes/humanize-date";
import { Truncate } from "../pipes/truncate";

// Components
import { HtmlEditor } from "../components/html-editor/html-editor";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";

// Pages
import { Home } from "../pages/home/home";
import { Articles } from "../pages/articles/articles";
import { Users } from "../pages/users/users";
import { Posts } from "../pages/posts/posts";
import { Login } from "../pages/login/login";
import { User } from "../pages/user/user";
import { Post } from "../pages/post/post";
import { Article } from "../pages/article/article";
import { Settings } from "../pages/settings/settings";
import { Value } from "../pages/value/value";
import { Health } from "../pages/health/health";
import { Emotion } from "../pages/emotion/emotion";
import { Tabs } from "../pages/tabs/tabs";
import { Blocked } from "../pages/blocked/blocked";
import {environment} from "../environments/environment";
import {CommentService} from "../providers/comment";

export const firebaseConfig = {
  apiKey: "AIzaSyA8tZphgoC6Ur-ayP5WeFqwVZfnMnbUaCA",
  authDomain: "harmonised-2fa4f.firebaseapp.com",
  databaseURL: "https://harmonised-2fa4f.firebaseio.com",
  storageBucket: "harmonised-2fa4f.appspot.com",
  messagingSenderId: "103658523574",
};

const firebaseAuthConfig = {
  provider: AuthProviders.Password,
  method: AuthMethods.Password,
};

// TagInputModule
@NgModule({
  declarations: [
    MyApp,
    Home,
    Articles,
    Users,
    Posts,
    Login,
    User,
    Post,
    Article,
    Settings,
    Value,
    Health,
    Emotion,
    Tabs,
    Blocked,
    HumanizeDate,
    PickTime,
    PickDate,
    ArticleDate,
    FormatTime,
    Truncate,
    HtmlEditor,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgxDatatableModule,
    IonicModule.forRoot(MyApp, {
      scrollAssist: false,
      autoFocusAssist: false,
      backButtonText: "     ",
      tabsHideOnSubPages: true,
    }),
    IonicStorageModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebaseConfig, firebaseAuthConfig),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    Home,
    Articles,
    Users,
    Posts,
    Login,
    User,
    Post,
    Article,
    Value,
    Health,
    Emotion,
    Settings,
    Tabs,
    Blocked,
    HtmlEditor,
  ],
  providers: [
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    Keyboard,
    StatusBar,
    SplashScreen,
    AssetService,
    FileService,
    PostService,
    CommentService,
    SettingsService,
    StatsService,
    UiService,
    UserService,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts